import React, { useState } from "react";
import Chatlist from "../Component/Chatlist";
import "../Style/Pages/Chatpage.css";
import Specificchat from "../Component/Specificchat";
const Chatpage = () => {
  const [selecteduser, setSelecteduser] = useState({});
  return (
    <div className="chatpage">
      <Chatlist onSelectUser={setSelecteduser} />
      <Specificchat user={selecteduser} />
    </div>
  );
};

export default Chatpage;
